class DetectScroll {
    settings;
    defaults = {
        speed: 0.09,
    };
    isResize = false;
    scrollId = '';
    scrollTop = 0;
    wrapperOffset = 0;
    elements = [];
    isTouchDevice = false;
    bodyHeight = 0;
    handlerScroll = [];
    currentWindowWidth = null;

    constructor(options) {
        this.settings = this.extend(this.defaults, options || {});
        this.isTouchDevice = DetectScroll.checkTouchDevice();
        this.compileConfig();
        this.currentWindowWidth = window.innerWidth;
    }

    compileConfig() {
        const elements = [];
        this.bodyHeight = 0;

        for (let i = 0, size = this.settings.config.length; i < size; i++) {
            const config = this.settings.config[i];
            if (!config.configName) throw `Не указан configName`;
            if (!config.element) throw `Не указан element`;

            const isHasEnd = typeof config.isHasEnd !== 'undefined' ? config.isHasEnd : true;
            const position = typeof config.position !== 'undefined' ? config.position : 'bottom';

            let start = DetectScroll.parseNumber(config.start);
            if (start === null) {
                start = elements[i - 1].end;
            }
            if ((new RegExp(/^[-+]/)).test(config.start)) {
                start = elements[i - 1].end + start;
            }

            let height = DetectScroll.parseNumber(config.height);

            let end = DetectScroll.parseNumber(config.end);
            if (end === null) {
                if (height === null || (new RegExp(/^[-+]/)).test(config.height)) {
                    config.element.classList.add('_show');
                    let heightTmp = 0;
                    if (window.innerWidth < main.mobileResolutionBorder) {
                        heightTmp = config.element.getBoundingClientRect().height;
                    } else {
                        for (let n = 0, count = config.element.childElementCount; n < count; n++) {
                            heightTmp += config.element.children[n].getBoundingClientRect().height;
                        }
                    }
                    config.element.classList.remove('_show');
                    end = start + heightTmp;

                    if ((new RegExp(/^[-+]/)).test(config.height)) {
                        end += height;
                    }
                } else {
                    end = start + height;
                }
            }

            if (height === null) height = end - start;

            const isShowed = typeof config.isShowed !== 'undefined' ? config.isShowed : start < window.innerHeight;

            if (isShowed) {
                config.element.classList.add('_show');
            } else {
                config.element.classList.remove('_show');
            }

            this.bodyHeight = Math.max(this.bodyHeight, end);

            const result = {
                'configName': config.configName,
                'element': config.element,
                'isHasEnd': isHasEnd,
                'position': position,
                'start': start,
                'end': end,
                'height': height,
                'callback': config.callback,
                'isShowed': isShowed
            };

            elements.push(result);
        }

        if (window.innerWidth >= main.mobileResolutionBorder) {
            document.body.style.height = this.bodyHeight + 'px';
        } else {
            document.body.style.height = '';
        }

        this.elements = elements;
    }

    init() {
        this.attachEvent();
        if (this.isTouchDevice) {
            window.addEventListener('scroll', this.animate.bind(this));
            window.addEventListener("touchmove", this.scroll.bind(this), false);
        } else {
            this.animate();
        }
    }

    getConfig(configName) {
        for (const element of this.elements) {
            if (element.configName === configName) return element;
        }

        throw 'Not found config for configName:' + configName;
    }

    get elements() {
        return this.elements;
    }

    extend() {
        const extended = {};
        let i = 0;
        const length = arguments.length;

        const merge = function (obj) {
            for (const prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    extended[prop] = obj[prop];
                }
            }
        };

        for (; i < length; i++) {
            const obj = arguments[i];
            merge(obj);
        }

        return extended;
    }

    static checkTouchDevice() {
        return (('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0) ||
            (navigator.msMaxTouchPoints > 0));
    }

    attachEvent() {
        window.addEventListener('resize', this.resize.bind(this));
    }

    resize() {
        if (this.currentWindowWidth === window.innerWidth && !this.isResize) {
            if (!this.isTouchDevice) {
                cancelAnimationFrame(Number(this.scrollId));
            }
            this.isResize = true;
            this.currentWindowWidth = window.innerWidth;
            setTimeout(function () {
                this.isResize = false;
                if (!this.isTouchDevice) {
                    this.scrollAnimate(true);
                    this.scrollId = requestAnimationFrame(this.animate.bind(this));
                } else {
                    this.scroll(null, true);
                }
            }.bind(this), 200);
        }
    }

    animate() {
        this.scrollAnimate();
        this.scrollId = requestAnimationFrame(this.animate.bind(this));
    }

    scrollAnimate(isForceCalc) {
        this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        const lastOffset = this.wrapperOffset;
        this.wrapperOffset += (this.scrollTop - this.wrapperOffset) * this.settings.speed;

        if (Math.round(this.wrapperOffset * 100) === this.scrollTop * 100) {
            this.wrapperOffset = this.scrollTop;
        }

        let direction;

        if (this.wrapperOffset > lastOffset) {
            direction = 1;
        } else {
            direction = -1;
        }

        if (lastOffset === this.wrapperOffset && !isForceCalc) return;

        this.checkElements({
            'globalOffset': this.wrapperOffset,
            'direction': direction,
            'globalScroll': this.scrollTop
        });
    }

    checkElements(data) {
        for (const elementInfo of this.elements) {
            let isVisible = false;
            let dataCalc = {};
            Object.assign(dataCalc, data);

            if (elementInfo.position === 'top' && elementInfo.start <= data.globalOffset && (!elementInfo.isHasEnd || elementInfo.end >= data.globalOffset)) {
                if (!elementInfo.isShowed) {
                    elementInfo.element.classList.add('_show');
                    elementInfo.isShowed = true;
                }
                dataCalc.localOffset = data.globalOffset - elementInfo.start;
                dataCalc.localScroll = data.globalScroll - elementInfo.start;
            } else if (elementInfo.position === 'bottom' && elementInfo.start <= data.globalOffset + window.innerHeight && (!elementInfo.isHasEnd || elementInfo.end >= data.globalOffset + window.innerHeight)) {
                if (!elementInfo.isShowed) {
                    elementInfo.element.classList.add('_show');
                    elementInfo.isShowed = true;
                }
                dataCalc.localOffset = data.globalOffset - elementInfo.start + window.innerHeight;
                dataCalc.localScroll = data.globalScroll - elementInfo.start + window.innerHeight;
            } else {
                if (elementInfo.isShowed) {
                    elementInfo.element.classList.remove('_show');
                    elementInfo.isShowed = false;
                }

                dataCalc.localOffset = data.globalOffset - elementInfo.start + window.innerHeight;
                dataCalc.localScroll = data.globalScroll - elementInfo.start + window.innerHeight;
            }

            dataCalc.start = elementInfo.start;
            dataCalc.end = elementInfo.end;
            dataCalc.height = dataCalc.end - dataCalc.start;

            if (elementInfo.start <= data.globalOffset + window.innerHeight && (!elementInfo.isHasEnd || elementInfo.end >= data.globalOffset)) {
                isVisible = true;
            }

            if (elementInfo.callback) {
                dataCalc.isShowed = elementInfo.isShowed;
                dataCalc.isVisible = isVisible;
                new Promise(() => {
                    elementInfo.callback(dataCalc);
                }).catch((error) => console.log(error));
            }
        }

        //this.#wrapper.style.transform = 'translate3d(0,' + Math.round(-this.wrapperOffset * 100) / 100 + 'px , 0)';
        //this.#fire(this.wrapperOffset, direction, this.scrollTop);

        this.fireScroll(data);
    }

    scroll(event, isForceCalc) {
        if (window.scrollY === this.scrollTop && !isForceCalc) return;

        let direction;

        if (window.scrollY > this.scrollTop) {
            direction = 1;
        } else {
            direction = -1;
        }

        this.scrollTop = window.scrollY;

        this.checkElements({
            'globalOffset': this.scrollTop,
            'direction': direction,
            'globalScroll': this.scrollTop
        });
    }

    getSingleScrollData(configName) {
        let elementInfo = null;

        for (const element of this.elements) {
            if (element.configName === configName) elementInfo = element;
        }

        let direction;

        if (window.scrollY > this.scrollTop) {
            direction = 1;
        } else {
            direction = -1;
        }

        const data = {
            'globalOffset': window.scrollY,
            'direction': direction,
            'globalScroll': window.scrollY
        };

        if (elementInfo === null) {
            console.log(`${configName} не найден! Переданные неполные данные скролла.`);
            return data;
        }

        if (elementInfo.position === 'top' && elementInfo.start <= data.globalOffset && (!elementInfo.isHasEnd || elementInfo.end >= data.globalOffset)) {
            if (!elementInfo.isShowed) {
                elementInfo.element.classList.add('_show');
                elementInfo.isShowed = true;
            }
            data.localOffset = data.globalOffset - elementInfo.start;
            data.localScroll = data.globalScroll - elementInfo.start;
        } else if (elementInfo.position === 'bottom' && elementInfo.start <= data.globalOffset + window.innerHeight && (!elementInfo.isHasEnd || elementInfo.end >= data.globalOffset + window.innerHeight)) {
            if (!elementInfo.isShowed) {
                elementInfo.element.classList.add('_show');
                elementInfo.isShowed = true;
            }
            data.localOffset = data.globalOffset - elementInfo.start + window.innerHeight;
            data.localScroll = data.globalScroll - elementInfo.start + window.innerHeight;
        } else {
            if (elementInfo.isShowed) {
                elementInfo.element.classList.remove('_show');
                elementInfo.isShowed = false;
            }

            data.localOffset = data.globalOffset - elementInfo.start + window.innerHeight;
            data.localScroll = data.globalScroll - elementInfo.start + window.innerHeight;
        }

        data.start = elementInfo.start;
        data.end = elementInfo.end;
        data.height = data.end - data.start;

        return data;
    }

    static parseNumber(number) {
        if (number === null || typeof number === 'undefined') return null;

        let result = parseFloat(number);

        if ((new RegExp(/^[-+]?\d+vh$/)).test(number)) {
            result = Math.max(window.innerHeight, 937) * (parseFloat(number) / 100);
        }

        return Math.ceil(result);
    }

    subscribeOnScroll(fn, thisObj) {
        let scope = thisObj || window;
        this.handlerScroll.push({'s': scope, 'f': fn});
    }

    fireScroll(data) {
        this.handlerScroll.forEach(function (item) {
            new Promise(() => {
                item.f.call(item.s, data);
            }).catch((error) => console.log(error));
        });
    }
}
